<template>
  <div class="">

    <!-- pagination toolbar -->
    <v-row class="align-center pl-4 pr-2 pt-2 pb-2">

      Select inventory item

    </v-row>

    <!-- pagination toolbar -->

    <table class="final-table th-no-padding lines-b pointer hover full-width">
      <colgroup ref="colgroup1">
        <col width="15px">
        <col width="15px">
        <col width="15px">
        <col width="15px">
        <col width="15px">
      </colgroup>

      <tr class="unselectable">
        <c-table-header
        title="Name"
        code="name"
        class="sticky"
        :filters="filters"
        @onClick="clickSortHeader">
        </c-table-header>

        <c-table-header
        title="R ID"
        code="archive_id"
        :filters="filters"
        @onClick="clickSortHeader">
        </c-table-header>

        <c-table-header
        title="Batch"
        code="batch_number"
        :filters="filters"
        @onClick="clickSortHeader">
        </c-table-header>

        <c-table-header
        title="Expiry"
        code="expiry_date"
        :filters="filters"
        @onClick="clickSortHeader">
        </c-table-header>

        <c-table-header
        title="Quantity"
        code="quantity"
        :filters="filters"
        @onClick="clickSortHeader">
        </c-table-header>
  
      </tr>

      <tr class="disable-hover">
        <td>
          <v-text-field
          v-model="filters.search.name"
          ref="nameSearchInput"
          placeholder="Search..."
          hide-details
          class="crx-box-input"
          clearable
          color="color1"
          solo
          @keydown.down.prevent="focusNextTableRow()"
          @keydown.up.prevent="focusPreviousTableRow()"
          @keydown.enter.prevent="onEnterKeyTableRow()">
          </v-text-field>
        </td>
        <td>
          <v-text-field
          v-model="filters.search.archive_id"
          placeholder="Search..."
          hide-details
          class="crx-box-input"
          clearable
          color="color1"
          solo></v-text-field>
        </td>
        <td>
          <v-text-field
          v-model="filters.search.batch_number"
          placeholder="Search..."
          hide-details
          class="crx-box-input"
          clearable
          color="color1"
          solo></v-text-field>
        </td>
        <td></td>
        <td></td>
      </tr>

      <row
      v-for="(item, i) in items" 
      :key="item.id"
      :item="item"
      :selected="selected"
      :searchFilters="filters.search"
      :active="currentIndex === i"
      :currentSelection="item.id === currentSelectedID"
      :disabled="exceptions.includes(item.id)"
      @click.native="clickRow(item)"
      @checkRow="checkRow(item)"
      ></row>

    </table>

    <div 
    v-if="items.length === 0"
    key="a"
    class="pa-4">

      <div class="display-1">
        No results found
      </div>

      <v-card>
        <v-img src="https://cdn.pixabay.com/photo/2017/04/08/22/26/meditation-2214532_1280.jpg">

        </v-img>
      </v-card>
    </div>

    <template v-if="$accessControl.userHasAccess(0, $store.state.auth.accessControl)">
      <json-viewer :item="items"></json-viewer>
      <json-viewer :item="mergePayload"></json-viewer>
      <json-viewer :item="mergePayloadMap"></json-viewer>
    </template>

    <!-- PAGINATION -->
    <c-pagination
    :page="page"
    :pagination="pagination"
    :filters="filters"
    @updatePageNumber="updatePageNumber"
    @goToFirstPage="goToFirstPage"
    @goToPreviousPage="goToPreviousPage"
    @goToNextPage="goToNextPage"
    @goToLastPage="goToLastPage"
    ></c-pagination>
    <!-- PAGINATION -->
  </div>
</template>

<script>
import Row from './Row'
import ServerListController from '@/mixins/ServerListController'
import ServerListBindings from '@/mixins/ServerListRouteBindings'
import ServerListKeyboardBindings from '@/mixins/ServerListKeyboardBindings'
import CSListItemsPerPage from '@/components/list-server/C-SListItemsPerPage'
import CTableHeader from '@/components/list-server/th'

export default {
  components: {
    Row,
    CSListItemsPerPage,
    CTableHeader
  },
  mixins: [ServerListController, ServerListBindings, ServerListKeyboardBindings],
  props: {
    exceptions: {
      default: () => [] // [id, id, id]
    },
    mergePayload: null // optional
    /*
    mergePayload = {
      savedInputs: [],
      items: [],
      mergeMap: {}
    }
    */
  },
  data () {
    return {
      filters: {
        rowsPerPage: 5,
        sortCol: 'archive_id',
        sortAscending: false,
        date: {
          mainSelect: 'is equal to',
          isInTheLast_select: 'days',
          isInTheLast_input: null,
          date1: null,
          date2: null,
        },
        search: {
          id: '',
          name: '',
          archive_id: '',
          batch_number: ''
        },
        active: {
          customer: false,
          date: false,
          deleted: false
        },
        categories: []
      },
      page: 0,
      currentSelectedID: null,
      currentIndex: 0,
      isLoading: false
    }
  },
  computed: {
    mergePayloadMap () {
      if (!this.mergePayload) {
        return {}
      }
      var map = {} // {inv_id: quantityModification} inv_id can be negative if no longer in inventory
      this.mergePayload.items.forEach(item => {
        var inv_id = item.inventory_id || this.mergePayload.mergeMap[item.id]
        if (!map[inv_id]) {
          map[inv_id] = -item.quantity
        } else {
          // if it exists
          map[inv_id] -= item.quantity
        }
      })
      this.mergePayload.savedInputs.forEach(item => {
        var inv_id = this.mergePayload.mergeMap[item.id]
        if (!map[inv_id]) {
          map[inv_id] = item.quantity
        } else {
          // if it exists
          map[inv_id] += item.quantity
        }
      })
      return map
    },
    rowsToAddDeprecated () {
      console.log('COMPUTING')
      if (!this.mergePayload) {
        return []
      }
      var rowsToAdd = []
      this.mergePayload.savedInputs.forEach(item => {
        var match = this.mergePayload.items.find(si_item => si_item.id === item.id)
        if (match) {
          console.log('match found')
          console.log(match)
          var match = JSON.parse(JSON.stringify(match))
          match.quantity = item.quantity - match.quantity
          match.tempID= null
          match.marking1 = true // maybe delete this in future? This is to mark it on the list row
          if (match.quantity > 0) {
            rowsToAdd.push(match)
          }
        } else { // if item is deleted from inputs but is still in saved inputs
          var copy = JSON.parse(JSON.stringify(item))
          console.log('HERE IS WHAT IM ADDING')
          console.log(copy)
          copy.isPseudo = true
          copy.marking2 = true
          copy.tempID = null
          rowsToAdd.push(copy)
        }
      })
      console.log(rowsToAdd)
      return rowsToAdd
    }
  },
  methods: {
    clickRow (item) {
      if (this.selectedCount > 0) {
        this.checkRow(item)
      } else {
        this.$emit('onItemSelected', item)
      }
    },
    focusFirstTextView () {
      setTimeout(() => {
        try {
          this.currentIndex = 0
          this.searchScreenSearch = ''
          this.$refs.nameSearchInput.focus()
        } catch (error) {
          console.log(error)
        }
      }, 50)
    },
    loadAPI: _.debounce(function (e) {
      return new Promise((resolve, reject) => {
        this.isLoading = true
        var data = {
          filters: this.filters,
          page: this.page
        }
        this.$axios.post(`/inventory`, data)
          .then(response => {
            var hrend = response.data.execution_time
            // console.log(hrend)
            // console.info('Execution time (hr): %ds %dms', hrend[0], hrend[1] / 1000000)
            var rows = response.data.rows
            this.pagination.rowCount = response.data.count
            this.pagination.pages = Math.ceil(this.pagination.rowCount / this.filters.rowsPerPage)

            if (this.items.length > rows.length) {
              this.currentIndex = 0
            }
            this.items = rows

            // this should be it
            this.items.map(item => {
              if (this.mergePayloadMap[item.id]) {
                item.quantity += this.mergePayloadMap[item.id]
              }
            })
            Object.keys(this.mergePayloadMap).forEach(key => {
              // the key is the mergemap id (can be negative)
              var quantityModification = this.mergePayloadMap[key]
              if (key < 0 && quantityModification > 0) {
                console.log(key)
                var match = this.mergePayload.savedInputs.find(item => this.mergePayload.mergeMap[item.id] === parseInt(key))
                if (match) {
                  console.log('MATCH FOUND')
                  console.log(match)
                  var copy = JSON.parse(JSON.stringify(match))
                  copy.quantity = quantityModification
                  copy.isPseudo = true
                  copy.marking2 = true
                  copy.tempID = null
                  this.items.push(copy)
                } else {
                  console.log('No match found')
                }
              }
            })

            // remerge saved inputs that where completely used from inventory, so no longer in the databases inventory,
            // but then deleted from the client side and not saved, so no longer accessible
            // this.items.push(...this.mergePayload.savedInputs)
            // this.items.push(...this.rowsToAdd)
            // maybe only show deleted items? not everything
          })
          .then(() => resolve())
          .catch(error => {
            console.log(error)
            this.$root.$errorSnackbar(error)
            reject(error)
          })
          .then(() => {
            this.isLoading = false
          })
      })
    }, 150, {leading: true}),
  },
  created () {
    this.loadAPI()
  }
}
</script>